/* Change this file to get your personal Porfolio */


// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Muhammad Ehsan - Data Scientist | ML, DL, NLP & Agentic AI",
  description:
    "Data Scientist specializing in Machine Learning, Deep Learning, NLP, and transitioning into Agentic AI and Generative AI. Building vertical AI solutions and LLM-driven automation for real-world applications.",
  og: {
    title: "Muhammad Ehsan - Data Scientist",
    type: "website",
    url: "https://muhammadehsan.me/",
  },
};

//Home Page
const greeting = {
  title: "Muhammad Ehsan",
  logo_name: "Muhammad Ehsan",
  subTitle:
    "I am Muhammad Ehsan, a Data Scientist with deep expertise in Machine Learning, Deep Learning and Natural Language Processing. My recent focus is on Agentic AI and Generative AI, where I design and implement advanced vertical AI solutions and develop real-world automation powered by Large Language Models (LLMs).",
  resumeLink:
    "https://drive.google.com/file/d/1AuT-HWGVuW7v8x7P-CU-dFLtTarEKlrV/view?usp=drive_link",
  portfolio_repository: "https://github.com/MuhammadEhsan02",
  githubProfile: "https://github.com/MuhammadEhsan02",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/MuhammadEhsan02",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/muhammad--ehsan/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:m.ehsan.ops@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Kaggle",
    link: "https://www.kaggle.com/muhammadehsan02",
    fontAwesomeIcon: "fa-kaggle", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  },
  {
    name: "Medium",
    link: "https://medium.com/@muhammad--ehsan",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/medium?style=brands
    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=medium
  },
];

const skills = {
  data: [
    {
      title: "Core Domains",
      fileName: "ArtificialIntelligenceImg",
      skills: [
        "⚡ Building predictive machine learning models for business and research",
        "⚡ Developing deep learning solutions for computer vision and advanced ML tasks",
        "⚡ Applying NLP for text analytics, sentiment analysis, and language understanding",
        "⚡ Leveraging LLMs and Generative AI for tailored industry solutions",
        "⚡ Creating Agentic AI, RAG systems, and vertical AI platforms for automation",
      ],
      softwareSkills: [
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",  
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Programming Languages",
      fileName: "ProgrammingImg",
      skills: [
        "⚡ Python for advanced data science, ML, and AI development",
        "⚡ R for statistical analysis and data visualization",
        "⚡ C++ for high-performance and scalable systems",
        "⚡ JavaScript for modern, interactive web applications",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "R",
          fontAwesomeClassname: "simple-icons:r",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "logos-c-plusplus",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos-javascript",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Data & Analytics",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Power BI for business intelligence and data visualization",
        "⚡ SQL for robust database management and querying",
        "⚡ Data analysis using Pandas, NumPy, Matplotlib, and Seaborn",
      ],
      softwareSkills: [
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos-pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Generative AI & LLMs",
      fileName: "AIAgentImg",
      skills: [
        "⚡ Fine-tuning and deploying LLMs (GPT, BERT, T5) for specific domains",
        "⚡ Building RAG (Retrieval-Augmented Generation) systems for knowledge-intensive applications",
        "⚡ Developing Agentic AI systems with autonomous reasoning and decision-making",
        "⚡ Creating conversational AI and chatbots using advanced NLP",
        "⚡ Implementing vector databases and semantic search for intelligent retrieval",
        "⚡ Building multi-modal AI systems combining text, image, and structured data",
      ],
      softwareSkills: [
        {
          skillName: "OpenAI GPT",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            backgroundColor: "transparent",
          },
        },
          {
            skillName: "Anthropic",
            fontAwesomeClassname: "simple-icons:anthropic",
            style: {
              backgroundColor: "transparent",
            },
          },
        {
          skillName: "Google Gemini",
          fontAwesomeClassname: "simple-icons:googlegemini",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Llama",
          fontAwesomeClassname: "simple-icons:meta",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudImg",
      skills: [
        "⚡ Deploying and managing solutions on GCP, AWS, and Azure",
        "⚡ Hosting and maintaining web apps with integrated databases",
        "⚡ Deploying deep learning models to the cloud for scalable access",
        "⚡ Setting up streaming data pipelines and cloud-based automation",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/muhammadehsan02",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/Muhammad--Ehsan/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/ehsanbhutto2",
    },
    {
      siteName: "DataCamp",
      iconifyClassname: "simple-icons:datacamp",
      style: {
        color: "#05192D",
      },
      profileLink: "https://www.datacamp.com/portfolio/muhammadehsan01",
    },
    {
      siteName: "Coursera",
      iconifyClassname: "simple-icons:coursera",
      style: {
        color: "#0056D2",
      },
      profileLink: "https://www.coursera.org/learner/muhammad-ehsan",
    },
  ],
};

const degrees = {
  degrees: [
    {
              title: "Sindh Madarsatul Islam University (SMIU)",
        subtitle: "BS Artificial Intelligence",
        logo_path: "smiu_logo.png",
        alt_name: "SMIU",
        duration: "2023 - 2027",
        descriptions: [
          "⚡ Currently pursuing Bachelor's degree in Artificial Intelligence",
          "⚡ Studying core AI concepts including machine learning, deep learning, and neural networks",
          "⚡ Learning programming fundamentals and mathematical foundations for AI",
        ],
        website_link: "https://smiu.edu.pk/",
      },
      {
        title: "NED University of Engineering & Technology",
        subtitle: "Undergraduate Diploma (UGD) - Artificial Intelligence & Data Science",
        logo_path: "ned_logo.png",
        alt_name: "NED University",
        duration: "2023 - 2024",
        descriptions: [
          "⚡ Completed comprehensive diploma in AI & Data Science with CGPA: 3.85/4.0",
          "⚡ Studied practical applications of machine learning and data analysis",
          "⚡ Gained hands-on experience with data science tools and methodologies",
        ],
        website_link: "https://www.neduet.edu.pk/",
      },
  ],
};

const bootcamps = {
  bootcamps: [
    {
      title: "Data Science with Python Bootcamp",
      subtitle: "- FAST NUCES",
      logo_path: "FAST-NU-logo.png",
      certificate_link: "https://verifybootcamp.netlify.app/certificate/4250170106733", 
      alt_name: "FAST NUCES",
      duration: "3 Months",
      color_code: "#0",
      description: "Completed an intensive 3-month bootcamp focused on Artificial Intelligence, covering machine learning, deep learning, and real-world AI applications."
    },
    {
      title: "Samsung Advance AI Training",
      subtitle: "- Muhammad Ali Jinnah University (MAJU)",
      logo_path: "maju_logo.png",
      certificate_link: "https://drive.google.com/file",
      alt_name: "Sample University",
      duration: "3 Months",
      color_code: "#0",
      description: "Completed a 3-month bootcamp in Data Science, focusing on data analysis, visualization, and practical machine learning techniques."
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Salesforce Certified Agentforce Specialist",
      subtitle: "- Salesforce",
      logo_path: "salesforce_logo.png",
      certificate_link: "https://trailhead.salesforce.com/en/credentials/verification/",
      alt_name: "Salesforce",
      color_code: "#00A1E0",
    },
    {
      title: "Professional Data Scientist",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/DS0026151635019",
      alt_name: "Data Scientist",
      color_code: "#2EC866",
    },
    {
      title: "Data Scientist Associate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/DSA0017483695584",
      alt_name: "Data Scientist",
      color_code: "#2EC866",
    },
    {
      title: "AI Engineer for Data Scientists Associate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/AEDS0017471650351",
      alt_name: "AI Engineer",
      color_code: "#2EC866",
    },
    {
      title: "Data Engineer Associate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/DEA0015300437949",
      alt_name: "Data Engineer",
      color_code: "#2EC866",
    },
    {
      title: "Data Analyst Associate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/DAA0019677360019",
      alt_name: "Data Analyst",
      color_code: "#2EC866",
    },
    {
      title: "SQL Associate Certificate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/certificate/SQA0015374638559",
      alt_name: "SQL Associate",
      color_code: "#2EC866",
    },
    {
      title: "Data Literacy Certificate",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/skill-verification/DL0039292774463",
      alt_name: "Data Literacy",
      color_code: "#2EC866",
    },
    {
      title: "AI Fundamentals",
      subtitle: "- DataCamp",
      logo_path: "datacamp_logo.png",
      certificate_link: "https://www.datacamp.com/skill-verification/AIF0025304526502",
      alt_name: "AI Fundamentals",
      color_code: "#2EC866",
    },

        // Coursera Specializations

    {
      title: "IBM AI Developer",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/professional-cert/G5J4PUX4X0D3",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    {
      title: "IBM AI Engineering",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/professional-cert/XGKVVPPNYORL",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    {
      title: "Generative AI Fundamentals",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/W47991069UFR",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    {
      title: "IBM Generative AI Engineering",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/professional-cert/63MZ0OGCGKUL",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    {
      title: "Generative AI Engineering with LLMs",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/KCNFH2ZX75BN",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    {
      title: "Generative AI for Data Scientists",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/6YINVHNZJ9TU",
      alt_name: "IBM",
      color_code: "#1F70C1",
    },
    
    {
      title: "Machine Learning",
      subtitle: "- DeepLearning.AI / Stanford University",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/7O3UMU6W5EMO",
      alt_name: "DeepLearning.AI",
      color_code: "#FF2c2c",
    },
    {
      title: "Generative AI for Software Development",
      subtitle: "- DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/professional-cert/D2IPHSJGL8Q4",
      alt_name: "DeepLearning.AI",
      color_code: "#FF2c2c",
    },
    {
      title: "AI for Good",
      subtitle: "- DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/H76JAG4MG1SH",
      alt_name: "DeepLearning.AI",
      color_code: "#FF2c2c",
    },

    {
      title: "Generative AI Assistants",
      subtitle: "- Vanderbilt University",
      logo_path: "Vanderbilt_University.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/UEVMW30KQ2Y5",
      alt_name: "Vanderbilt University",
      color_code: "#2A73CC",
    },
    {
      title: "AI Agent Developer",
      subtitle: "- Vanderbilt University",
      logo_path: "Vanderbilt_University.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/M37BM5V1OU2B",
      alt_name: "Vanderbilt University",
      color_code: "#2A73CC",
    },
    {
      title: "AI Agents & Agentic AI in Python: Powered by Generative AI",
      subtitle: "- Vanderbilt University",
      logo_path: "Vanderbilt_University.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/ESDK7TNTDI61",
      alt_name: "Vanderbilt University",
      color_code: "#2A73CC",
    },
    {
      title: "Agentic AI and AI Agents for Leaders",
      subtitle: "- Vanderbilt University",
      logo_path: "Vanderbilt_University.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/Q2BXBM41GGEN",
      alt_name: "Vanderbilt University",
      color_code: "#2A73CC",
    },

    {
      title: "MLOps | Machine Learning Operations",
      subtitle: "- Duke University",
      logo_path: "Duke_University.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/85NOK3FH4HCD",
      alt_name: "Duke University",
      color_code: "#2A73CC",
    },

    {
      title: "AI Engineering",
      subtitle: "- Scrimba",
      logo_path: "Scrimba_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/MQI6924PPYZZ",
      alt_name: "Scrimba",
      color_code: "#2A73CC",
    },
    {
      title: "Introduction to Generative AI Learning Path",
      subtitle: "- Google Cloud",
      logo_path: "gcp_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/specialization/51JDCOLKQ1HZ",
      alt_name: "Google Cloud",
      color_code: "#2A73CC",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "Data Scientist with experience in ML models, analytics dashboards, NLP automation, and LLM-integrated solutions. Passionate about building intelligent systems and transitioning into Agentic AI and Generative AI applications.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Freelance Data Scientist",
          company: "Upwork",
          company_url: "https://www.upwork.com/",
          logo_path: "upwork_logo.png",
          duration: "December 2023 - Present",
          location: "Remote",
          description:
            "Working with clients on ML models, analytics dashboards, NLP automation, and LLM-integrated solutions. Building custom AI applications and data-driven insights for various industries.",
          color: "#14A800",
        },
        {
          title: "BI Analyst",
          company: "View Store",
          company_url: "https://viewstore.com/",
          logo_path: "view_store_logo.png",
          duration: "October 2023 - January 2024",
          location: "Karachi (Hybrid)",
          description:
            "Built Power BI dashboards, analyzed business trends, and worked with SQL-based pipelines. Provided data-driven insights to support business decision-making processes.",
          color: "#0078D4",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Science Intern",
          company: "The Sparks Foundation",
          company_url: "https://thesparksfoundationsingapore.org/",
          logo_path: "tsf_logo.png",
          duration: "September 2023 - October 2023",
          location: "Remote",
          description:
            "Worked on a project to predict the number of bank customers who will leave the bank. I used Logistic Regression, Random Forest, and XGBoost models to build a predictive model. I also used feature engineering and data visualization techniques to improve the model's performance.",
          color: "#000000",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Co-Founder",
          company: "UpTo Web",
          company_url: "https://uptoweb.com/",
          logo_path: "uptoweb_logo.jpeg",
          duration: "October 2023 - Present",
          location: "Karachi, Pakistan",
          description:
            "Co-founded an initiative to help university students build real-world, industry-relevant skills through recorded lectures, hands-on sessions, and learning materials. Focused on bridging the gap between academic knowledge and practical application in tech fields like web development.",
          color: "#4285F4",
        },
        {
          title: "Volunteer and Student Ambassador",
          company: "The Indus Hospital",
          company_url: "https://indushospital.org.pk/",
          logo_path: "indus_logo.png",
          duration: "May 2024 - May 2024",
          location: "Karachi, Pakistan",
          description:
            "Motivated university students to actively participate in life-saving initiatives through blood donation drives. Assisted the hospital team during on-campus blood bank camps and contributed to awareness and outreach efforts through marketing activities.",
          color: "#D83B01",
        },
        {
          title: "Github Contributor",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "2024 - Present",
          location: "Remote",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "AI & ML Projects",
  description:
    "Showcasing cutting-edge AI/ML projects including Large Language Models, Agentic AI systems, Computer Vision applications, and production-ready machine learning solutions deployed on cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "Autonomous_by_Design_Zero_Touch_Security_Architecture_for_6G_Driven_Intelligent_e_Health_Networks",
      name: "Autonomous by Design: Zero-Touch Security Architecture for 6G-Driven Intelligent e-Health Networks",
      createdAt: "2026-07-31T00:00:00Z",
      description: "IEEE Internet of Things Magazine",
      url: "https://ieeexplore.ieee.org/document/11635940",
    },
    {
      id: "Edge_Enabled_Collaborative_Localization_With_Task_Oriented_Communication_for_Multi_Agent_Embodied_AI_in_Smart_Factories",
      name: "Edge-Enabled Collaborative Localization With Task-Oriented Communication for Multi-Agent Embodied AI in Smart Factories",
      createdAt: "2026-06-22T00:00:00Z",
      description: "IEEE Internet of Things Magazine",
      url: "https://ieeexplore.ieee.org/document/11573827",
    },
    {
      id: "Toward_Agentic_AI_Intrusion_Detection_and_Self_Healing_Security_for_UAV_Network_in_Next_Generation_Wireless_Systems",
      name: "Toward Agentic AI Intrusion Detection and Self-Healing Security for UAV Network in Next-Generation Wireless Systems",
      createdAt: "2026-05-14T00:00:00Z",
      description: "IEEE Network",
      url: "https://ieeexplore.ieee.org/document/11520549",
    },
    {
      id: "Multi_Agent_Federated_Edge_Learning_for_UAV_IDS_in_Smart_City_IoT_Environment",
      name: "Multi-Agent Federated Edge Learning for UAV-IDS in Smart City IoT Environment",
      createdAt: "2026-02-23T00:00:00Z",
      description: "IEEE Transactions on Consumer Electronics",
      url: "https://ieeexplore.ieee.org/document/11406128",
    },
    {
      id: "GenFed_IDS_A_Lightweight_Federated_Generative_AI_Framework_for_UAV_Anomaly_Detection_in_Rescue_Operations",
      name: "GenFed-IDS: A Lightweight Federated Generative AI Framework for UAV Anomaly Detection in Rescue Operations",
      createdAt: "2026-01-28T00:00:00Z",
      description: "IEEE Transactions on Consumer Electronics",
      url: "https://ieeexplore.ieee.org/document/11366942",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ehsan.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Machine Learning, Deep Learning, Large Language Models, Generative AI and Agentic AI Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://medium.com/@muhammad--ehsan",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Saratoga Ave, San Jose, CA, USA 95129",
    locality: "San Jose",
    country: "USA",
    region: "California",
    postalCode: "95129",
    streetAddress: "Saratoga Avenue",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },

  phoneSection: {
    title: "Phone",
    subtitle: "+92 314 1721775",
  },  
};

// Projects Section
const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELP TO CREATE THEIR TECH",
  projects: [
    {
      image: "saayaHealthLogo.png",
      link: "https://saayahealth.com/",
    },
    {
      image: "nextuLogo.jpg",
      link: "https://nextu.se/",
    },
  ],
};

// Open Source Section
const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN || "YOUR_GITHUB_TOKEN",
  githubUserName: "MuhammadEhsan02",
};

// Projects Data
const projects = {
  data: [
    {
      id: "coming-soon",
      name: "Coming Soon",
      createdAt: "2024-01-01T00:00:00Z",
      url: "#",
      description: "Featured ML & GenAI projects in progress. Stay tuned for cutting-edge AI applications including Large Language Models, Agentic AI systems, and Generative AI solutions.",
      isFork: false,
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python"
        },
        {
          name: "AI/ML",
          iconifyClass: "simple-icons:artificialintelligence"
        }
      ]
    }
  ]
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  bootcamps,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  bigProjects,
  openSource,
  projects,
};
